import { useOrders } from "context/useOrderData";
import { OrderStatus, SaleStatus } from "models/WebShop";
import React from "react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

const OrderOverview = () => {
    const params = useParams();
    const { saleStatusByCompany } = useOrders();
    const [saleStatuses, setSaleStatuses] = useState<OrderStatus[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const getData = async () => {
            if (!loaded && params.id !== undefined) {
                const response = saleStatusByCompany[params.id];
                if (response !== undefined && response.orderStatuses !== undefined) {
                    setSaleStatuses(response.orderStatuses);
                }
                setLoaded(true);
            }
        };
        getData();
    }, [loaded, params.id]);


    const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};


    return (
        <div className="card">
            <div className="card-body">
                <h1 className="h3">Ordre</h1>
                {loaded ?

                    saleStatuses.length > 0 ?
                        (
                            <>
                                <div className="cc-scroll-wrapper">
                                    <div className="table-responsive" id="scrollContainer">
                                        <table className="table cc-table">
                                            <tbody>
                                                <tr>
                                                    <th>Dato</th>
                                                    <th>Ordrenr.</th>
                                                    <th>Vare</th>
                                                    <th>Pris</th>
                                                    <th>Status</th>
                                                </tr>
                                                {saleStatuses.length > 0 ? <>



                                                    {saleStatuses.map((s, index) => {
                                                        const totalPrice = s.activeProducts?.reduce((sum, product) => sum + product.price, 0) || 0;

                                                        return (
                                                            <React.Fragment key={s.saleId}>
                                                                <tr>
                                                                    <td>{formatDate(s.createdOn)}</td>
                                                                    <td>{s.saleId}</td>
                                                                    <td>{s.isMinBedriftSale ? "Utvidet informasjon" : "Varer" }</td>
                                                                    <td>{totalPrice.toFixed(2)},-</td>
                                                                    <td>{SaleStatus[s.saleStatus]}</td>
                                                                </tr>
                                                                {s.activeProducts && s.activeProducts.length > 0 && (
                                                                    s.activeProducts.map((product, idx) => (
                                                                        <tr key={`${s.saleId}-product-${idx}`}>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td className="text-muted">
                                                                                <div className="d-flex align-items-start gap-1">
                                                                                <i className="bi bi-arrow-return-right"></i><span>{product.productName}</span> 
                                                                                </div>
                                                                            </td>
                                                                            <td className="text-muted">{product.price.toFixed(2)},-</td>
                                                                            <td>{product.leveringsStatus}</td>
                                                                        </tr>
                                                                    ))
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}

                                                </> : <tr><td colSpan={4}>Her var det tomt</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        )
                        : <>Ordreoversikten er tom.</>

                    : (
                        <span className="spinner-border spinner-border-sm"></span>
                    )}
                <p className="mt-4 mb-0">
                    <Link to={`${UrlPath.MyAccount.Home}/`} className="btn btn-outline-primary"><i className="bi bi-arrow-left"></i> Tilbake</Link>
                </p>
            </div>
        </div>
    );
};

export default OrderOverview;
